export default {
    PRODUCTION: 'production',
    DEBUG: 'debug',
    UNIT_TESTING: 'unit-testing',
    DEVELOPMENT: 'development',
};
